import { KoddiAPIClass } from './api';

/**
 * The Koddi API Instance. This is the global application data fetching layer.
 */
const KoddiAPI = new KoddiAPIClass();
KoddiAPI.createPublicAPI();

export default KoddiAPI;
